import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import SearchSmallIcon from 'icons/SearchSmall.icon';
import { getHasElementsInArray } from 'utils';

import './RecentSearches.styles.scss';

type RecentSearchesProps = {
  className?: string;
  searches: string[];
  onSelect: (searchString: string) => void;
};

const RecentSearches: FC<RecentSearchesProps> = (props) => {
  const { className, searches, onSelect } = props;

  const { t } = useTranslation();

  const classes = classNames('recent-searches', className);

  if (!getHasElementsInArray(searches)) return null;

  return (
    <div className={classes}>
      <h3>{t('tryOneOfYourRecentSearches')}</h3>

      <ul className="recent-searches__list">
        {searches.map((search) => (
          <li key={search}>
            <Button
              variant="outline"
              className="recent-searches__pill"
              icon={SearchSmallIcon}
              onClick={() => onSelect(search)}
            >
              {search}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentSearches;
